import React from "react";
import Image from "../assets/IAM-Advisory-6.png";
import { Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { FaQuoteLeft } from "react-icons/fa";
import { FaQuoteRight } from "react-icons/fa";
import { SiTicktick } from "react-icons/si";
import BG from "../assets/Blue.png";
import Footer from "../components/Footer";
import "../utils/effectCSS/Effects.css";

const IAMAdvisoryServices = () => {
  return (
    <>
      <Container
        fluid
        className="py-5"
        style={{
          backgroundImage: "url(" + BG + ")",
        }}
      >
        <div
          style={{
            height: "70px",
          }}
        ></div>
        <h2 className="text-center p-4">
          <b>IAM Advisory Services</b>
        </h2>

        <hr
          className="d-flex justify-content-center"
          style={{
            width: "10%",
            border: "1.5px solid blue",
            margin: "0 auto",
          }}
        />

        <div className="mt-5">
          <Row>
            <Col lg={2} className="d-flex justify-content-end">
              <FaQuoteLeft
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>

            <Col lg={8}>
              <Container fluid className="text-center">
                <p
                  style={{
                    fontSize: "1.25rem",
                  }}
                >
                  Building a robust security program begins with a clear vision of your ultimate goal. Once that vision is established, every Action, Policy, and Tool should align with that end. Regularly revisit and refine the process to adapt to evolving challenges and ensure continuous improvement.
                </p>
              </Container>
            </Col>

            <Col
              lg={2}
              className="d-flex align-items-start justify-content-start"
            >
              <FaQuoteRight
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>
          </Row>
        </div>
        <Container>
          <Row className="mt-5 align-items-stretch">
            <Col className="d-flex" lg={6} xs={12}>
              <img className="img-fluid" src={Image} alt="IAM" />
            </Col>
            <Col className="d-flex" lg={6} xs={12}>
              <Container
                className="flex-fill"
                style={{
                  backgroundColor: "#6495ED",
                  color: "white",
                  padding: "4rem 2rem",
                }}
              >
                <h4 className="">
                  Innovative IAM Solutions for Modern Enterprises
                </h4>

                <div className="mt-2">
                  <ListGroup className="border-0 bg-transparent ">
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Identity Lifecycle Management (ILM)
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Security Development & Operations (SecDevOps)
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Emerging Security & AI
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Identity Audit & SIEM Integration
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      On-Premises, Cloud, and Hybrid Integrations
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Federation Services
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Roles and Access Management
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Authentication & Authorization Services
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Directory Services
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      IAM Governance
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Privilege Access Management (PAM)
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Container>
            </Col>
          </Row>
        </Container>
        <Card className="bg-transparent border border-0 text-black p-5 text-center">
          <Card.Body>
            <h3 className="text-center mb-4">
              <b>
                Evaluate Your IAM Posture Before Hackers
                Strike
              </b>
            </h3>
            <hr
              className="d-flex justify-content-center"
              style={{
                width: "10%",
                border: "1.5px solid blue",
                margin: "0 auto",
              }}
            />
            <Container>
              <Row xs={1} lg={3}>
                <Col lg={2}></Col>
                <Col lg={8} className="mt-4">
                  <p
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                   In today’s Digital Landscape, A robust Identity and Access Management (IAM) strategy is crucial to safeguarding your organization’s sensitive data and systems. Proactively assessing your IAM posture helps identify vulnerabilities, strengthen access controls, and ensure compliance with evolving security standards.
                  </p>
                  <p
                    className="mt-5"
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                    At IDM 360 Analytics, We analyze your security posture to craft a tailored implementation strategy that empowers informed decision-making. Our IAM advisory services don’t stop at identifying Tools and Technologies; we deliver actionable insights to help you build a seamless and future-ready IAM framework. Rely on IDM 360 Analytics for solutions that align with your business objectives while fortifying your Organization's Security and Resilience.
                  </p>
                </Col>
                <Col lg={2}></Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>

        <Container className="p-0">
          {/* First Row */}
          <Row className="justify-content-center g-3 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Design and Architecture Evaluation</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  Our Design and Architecture Evaluation service meticulously reviews your IAM setup to ensure it is Secure, Scalable, and Aligned with your Business Objectives. By identifying gaps and optimizing your IAM design, we ensure your Organization is prepared to face evolving Security challenges, Protecting both critical data and user access. We help you strengthen your IAM framework before vulnerabilities are exploited.
                </p>
              </Container>
            </Col>
          </Row>
          {/* Second Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={6} className="d-flex order-2 order-lg-1 hover-left">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  We focus on securing your IAM framework through full-scale automation, ensuring that your systems are constantly protected and optimized. Our approach automates critical IAM processes, reducing manual errors and enhancing efficiency. By streamlining workflows and integrating automation at every level, We ensure that your IAM posture remains Strong, Agile, and Prepared to defend against emerging Threats.
                </p>
              </Container>
            </Col>

            <Col lg={4} className="d-flex order-1 order-lg-2 hover-right">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#1ca9c9",
                  color: "white",
                }}
              >
                <h5>Full- scale Automation</h5>
              </Container>
            </Col>
          </Row>
          {/* Third Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>IAM Talent Advisory</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  Our advisory services guide you in building a strong IAM workforce, from identifying talent gaps to recommending strategic training and recruitment. With the right talent driving your IAM strategy, you can proactively secure your digital landscape against potential threats. We help you evaluate your team’s skills to ensure they’re equipped to manage and secure your IAM systems.
                </p>
              </Container>
            </Col>
          </Row>
        </Container>
      </Container>
      <div className="mt-4">
        <Footer />
      </div>
    </>
  );
};

export default IAMAdvisoryServices;
